var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-background"},[_c('div',{staticClass:"error d-flex justify-content-center align-items-center"},[_c('BadRequestContent')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }